export default __webpack_public_path__ + "static/media/Wrongans.39acee08.png";